import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { PrintersPage } from './_dashboard.devices.printers'

export const Route = createFileRoute('/_dashboard/devices/printers/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: PrintersIndexPage,
})

function PrintersIndexPage() {
  return <PrintersPage selectedId={undefined} />
}
